import definePopup from './definePopup'
import PopupComponent from './PopupComponent'

const Popup = definePopup()

export { PopupComponent, Popup }
